resizeBy// ie: Engine.ui.misc();
jQuery(function ($) {
    "use strict";
    var Engine = {
        ui: {
            misc: function () {
                $(function () {
                    // Add .scrolled class to header when scroll position > 100px
                    $(window).on('scroll', function () {
                        if ($(this).scrollTop() > 100) {
                            $('header').addClass('scrolled');
                        } else {
                            $('header').removeClass('scrolled');
                        }
                    });

                    // Smooth scroll for anchor links
                    $('a[href^="#"]').on('click', function (e) {
                        e.preventDefault();

                        // Get the target element
                        var target = $(this.hash);
                        if (target.length) {
                            // Animate scroll to target with 100px offset
                            $('html, body').animate({
                                scrollTop: target.offset().top - 100
                            }, 800);

                            // Update URL without the hash
                            if (history.pushState) {
                                history.pushState(null, null, ' ');
                            } else {
                                location.hash = '';
                            }
                        }
                    });

                    // Append arrow indicator to dropdown parent links.
                    // tabindex="0" makes it focusable so .arrow:focus can reveal the menu.
                    $('.menu-item-has-children').append('<span class="arrow" tabindex="0"></span>');

                    // Toggle the sibling .dropdown-menu open/closed when the arrow is clicked.
                    $(document).on('click', '.arrow', function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        const $arrow = $(this);
                        const $menu = $arrow.siblings('.dropdown-menu');
                        const isOpen = $menu.css('display') === 'grid';
                        $menu.css('display', isOpen ? '' : 'grid');
                        $arrow.css('transform', isOpen ? '' : 'rotate(180deg)');
                    });

                    let isOpen = false;

                    $("#menuIcon").on('click', function () {
                        if (!isOpen) {
                            // Transition to Close Icon (X)
                            $('.top').attr('d', 'M1 1L19 15');
                            $('.middle').css('opacity', '0');
                            $('.bottom').attr('d', 'M1 15L19 1');
                        } else {
                            // Transition to Hamburger Menu Icon
                            $('.top').attr('d', 'M2 2H25');
                            $('.middle').css('opacity', '1');
                            $('.bottom').attr('d', 'M2 18H25');
                        }

                        isOpen = !isOpen;
                    });



                    // Products carousel — variable width, ~4 visible on desktop,
                    // with pagination dots that only show on mobile.
                    new Swiper('.products-swiper', {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        grabCursor: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        },
                        pagination: {
                            el: '.products-pagination',
                            clickable: true,
                        },
                        breakpoints: {
                            768: {
                                spaceBetween: 24,
                            },
                        },
                    });

                    // Popular courses carousel — variable-width like products,
                    // with pagination dots that only show on mobile.
                    new Swiper('.popular-courses-swiper', {
                        slidesPerView: 'auto',
                        spaceBetween: 20,
                        grabCursor: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        },
                        pagination: {
                            el: '.popular-courses-pagination',
                            clickable: true,
                        },
                        breakpoints: {
                            768: {
                                spaceBetween: 24,
                            },
                        },
                    });

                    // Testimonials carousel — 1 slide below 768px, 2 above.
                    new Swiper('.testimonials-swiper', {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        grabCursor: true,
                        autoplay: {
                            delay: 5000,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        },
                        breakpoints: {
                            768: {
                                slidesPerView: 2,
                                spaceBetween: 24,
                            },
                        },
                    });

                    $(window).on('scroll', function () {
                        if ($(this).scrollTop() > 1000) {
                            $('#back-top').fadeIn();
                            $("#back-top").addClass('active');
                        } else {
                            $('#back-top').fadeOut();
                            $("#back-top").removeClass('active');
                        }
                    });

                    $('#back-top').on('click', function () {
                        $('body,html').animate({
                            scrollTop: 0
                        }, 100);
                        return false;
                    });

                    // Checkout — swap Place Order button to a loading state on submit.
                    // WooCommerce fires `checkout_error` if validation fails, so we
                    // restore the original label in that case.
                    const $checkoutForm = $('form.woocommerce-checkout');
                    if ($checkoutForm.length) {
                        const loadingLabel = 'Placing order…';
                        let originalLabel = '';

                        $checkoutForm.on('submit', function () {
                            const $btn = $('#place_order');
                            if (!$btn.length || $btn.hasClass('is-loading')) {
                                return;
                            }
                            originalLabel = $btn.text();
                            $btn
                                .addClass('is-loading')
                                .prop('disabled', true)
                                .html('<span class="aiims-spinner" aria-hidden="true"></span>' + loadingLabel);
                        });

                        $(document.body).on('checkout_error', function () {
                            const $btn = $('#place_order');
                            if (!$btn.hasClass('is-loading')) {
                                return;
                            }
                            $btn
                                .removeClass('is-loading')
                                .prop('disabled', false)
                                .text(originalLabel);
                        });
                    }

                });
            }, // end misc
        }, // end ui
        //utils: {

        //}, // end utils
    };
    Engine.ui.misc();
    //Engine.utils.sliders();
});
